import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from '../../../Axios/axios';

import * as repositoryActions from '../../../Store/Actions/repositoryActions';
import * as globalActions from '../../../Store/Actions/globalActions';
import * as notificationAction from '../../Components/Modules/Notification/notificationActions';

import ModalForm from '../../Components/Modal/modal';
import TreeView from '../../Components/TreeView/treeview';
import ListView from '../../Components/ListView/listview';

 // START CLASS  //////////////////////////////////////////////////////
class TreeListSplit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page:0,
            items:[],
            formData:{name:"",create:false,object:{}},
            selectedObjectId:0,
            parentId:0,
        }
    }

    componentDidMount = () =>{

    }
    //UPDATE STATE FROM PROPS
    static getDerivedStateFromProps(props, current_state) {
      // COMPUTE
      return null //STATE
    }
    // DEFAULT METHOD END /////////////////////////////
    ///////////////////////////////////////////////////







    //////////////////////////////////////////////////
    //  INNER METHOD    //////////////////////////////
    onSelectListItem= (action) =>{
        console.log("ACTION",action);
        var node = this.props._currentNode;
        switch(action.action){
          case "Update":
            var formData = {...this.state.formData};
            formData.create=false;
            formData.name=node.name;
            this.setState({formData:formData,showForm:true,selectedObjectId:action.object.ARCS});
            break;
          case "Add":
            var formData = {...this.state.formData};
            formData.create=true;
            formData.name=node.name;
            this.setState({formData:formData,showForm:true,selectedObjectId:0});
            break;
          case "Archive":
            // CONFIRM ARCHIVE
            this.onArchive(action.object);
            //this.props._delete_single_object(this.props.sessionId,action.object[action.config.id],this.props._currentNode,action.object);
            
            this.setState({showForm:false,activeAction:action});
            break;
          case "Unarchive":
            // CONFIRM UNARCHIVE
            this.onUnArchive(action.object);
            //this.props._unarchive_single_object(this.props.sessionId,action.object[action.config.id],this.props._currentNode,action.object,this.props.pagination);
            // ETAT 0 -> FLAG 0
            this.setState({showForm:false,activeAction:action});
            break;
          default:
            break;
        }
    }

    clearSubLevel = () =>{
        this.props._update_sublevel("");
        this.setState({showForm:false,page:0});
        this.props._clean_data();
    }

    getDataSet = (node,resetPage,term) =>{
        var to = {...this.props._transfertObject};
        var parent_id=0;
        to.ObjParamDto = null;
        //enable paginate
        to.ObjParamsDto.bPageIsActive = true;
        to.ObjParamsDto.iPageNumber = resetPage?0:this.state.page+1;
        to.ObjParamsDto.sPageFilter = term;
        //GET ARCS_TP_N3
        if(typeof node.endpoint !== "undefined"){
            // IF NODE.SUBTYPE IS NOT EMPTY GET THE TDI ID RELATED
            if(node.subType !== undefined){
              if(this.props._TDI.filter(item=>item.CODE ===node.subType).length>0){
                to.ObjParamsDto.ARCS_TP_N3 = this.props._TDI.find(item=>item.CODE ===node.subType).ARCS;
              }  
            }
            if(node.parent !== undefined){
                parent_id =  this.props._TDI.find(item=>item.CODE ===node.parent).ARCS;
            }
            if(node.endpoint === "DOC"){
              var tmp = {...to.ObjParamsDto};
              to.ObjParamsDto = {};
              to.ObjParamsDto.SessionIDE = tmp.SessionIDE;
              to.ObjParamsDto.PER_ARCS = 2;
              to.ObjParamsDto.CODE_02 = 0;
              to.ObjParamsDto.TP_NN = 0;
              to.ObjParamsDto.ARCS = 0;
              to.ObjParamsDto.Locked = 0;
              to.ObjParamsDto.CD = "";
              to.ObjParamsDto.SV = 0;
              to.ObjParamsDto.LNH = tmp.LNH;
              to.ObjParamsDto.ETAT = 0;
              to.ObjParamsDto.RecordFlag = tmp.RecordFlag;
              to.ObjParamsDto.sPageFilter="";
              to.ObjParamsDto.bPageIsActive=true;
              to.ObjParamsDto.iPageNumber=0;
              to.ObjParamsDto.iPageWeigth=40;
              to.ObjParamsDto.iPageSort="";
            }
        }

        //GET DATA
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"ECLoad", to)
        .then(response => {
            var list = [...this.state.items];
            list = list.concat(response.data);
            this.setState({page:resetPage?0:this.state.page+1,items:resetPage?response.data:list,parentId:parent_id});
            
        }).catch(error => {
            this.props._logError(error,"ERROR Getting data", node.endPoint);
            console.log("ERROR:",error);
        }).finally(res=>{

        });


    }

    // POP UP METHODS //////////////////////////////////
    onPopupSave = () =>{
        var node = this.props._currentNode;
        var to = {...this.props._transfertObject};
        to.ObjParamsDto = null;
        to.ObjDataDto = this.props._newObject;
        //SAVE
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"Save", to)
        .then(response => {
            
        }).catch(error => {
            this.props._logError(error,"ERROR Saving data", node.endPoint);
            console.log("ERROR:",error);
        }).finally(res=>{
            // RELOAD DATA LIST TO GET LATEST UPDATE
            this.getDataSet(node,true,"");
        });
        
        
        this.props._onCloseForm(true);
        this.setState({showForm:false});
    }
    onClosePopup = (saved) =>{
        if(this.props._newObject.ARCS ===0){
          console.log("nothing to release");
          this.props._onCloseForm();
        }else{
            if(saved){
                console.log("objectToSave",this.props._loadedObject);
             }else{
                console.log("objectToRelease",this.props._loadedObject);
            }
          this.props._onCloseForm();
        }
        this.setState({showForm:false,activeObject:null,selectedObjectId:0});
    
    }
    onArchive = (object) =>{
        var node = this.props._currentNode;
        var to = {};
        to.ObjDataDto = object;
        to.ObjParamDto = {...this.props._transfertObject.ObjParamDto};
        // ETAT 255 -> FLAG 255 = ARCHIVE
        to.ObjParamDto.ETAT = 255;
        to.ObjParamDto.ARCS = object.ARCS;
        to.Session = {...this.props._transfertObject.Session};
        //Archive
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"GUIAccessFlag", to)
        .then(response => {
            
        }).catch(error => {
            this.props._logError(error,"ERROR Archiving data", node.endPoint);
            console.log("ERROR:",error);
        }).finally(res=>{
            // RELOAD DATA LIST TO GET LATEST UPDATE
            this.getDataSet(node,true,"");
        });
    }
    onUnArchive = (object) =>{
        var node = this.props._currentNode;
        var to =  {...this.props._transfertObject};;
        to.ObjDataDto = object;
        to.ObjParamDto = {...this.props._transfertObject.ObjParamDto};
        // ETAT 255 -> ETAT 0 = UNARCHIVE
        to.ObjParamDto.ETAT = 0;
        to.ObjParamDto.ARCS = object.ARCS;
        to.Session = {...this.props._transfertObject.Session};
        //UnArchive
        axios.ArcsAxios.post("/WCFWindowsArcs/"+node.endpoint+"GUIAccessFlag", to)
        .then(response => {
            
        }).catch(error => {
            this.props._logError(error,"ERROR Archiving data", node.endPoint);
            console.log("ERROR:",error);
        }).finally(res=>{
            // RELOAD DATA LIST TO GET LATEST UPDATE
            this.getDataSet(node,true,"");
        });
    }


    // INNER METHOD END   /////////////////////////////
    ///////////////////////////////////////////////////







    

    //////////////////////////////////////////////////
    //  RENDER METHOD   //////////////////////////////
    buildContent = () =>{
        var buildTreeView = this.buildTreeView();
        var listView = this.buildListContent();


      return(
        <div className="view-outer-content">
            {buildTreeView}
            {listView}
        </div>
      );
    }

    buildTreeView = () =>{
        return (
        <div className="object-explorer">
          <div className="explorer-header">
            <span>Explorer ({this.props.explorerItem.displayName})</span>
            <span className="icon" onClick={this.clearSubLevel.bind()}><FontAwesomeIcon icon="times"/></span>
          </div>
          <div className="explorer-content">
            <TreeView nodes={this.props._nodes[this.props.explorerItem.name]} page={this.state.page} getDataSet={this.getDataSet.bind(this)}/>
          </div>
        </div>
        )
    }

    buildListContent = () =>{
        var config = Object.keys(this.props._currentNode).length>0?this.props._currentNode.config:null;
        if(config!==null){config.editable = true;}
        //var content = this.props._dataset.length>0?<ListView node={this.props._currentNode} toolbarReturn={this.onSelectListItem.bind()} getDataSet={this.getDataSet.bind(this)} onSelectItem={null} config={this.state.listviewConfig} listItem={this.props.workingData}/>:null;
        var content = this.state.items.length>0?<ListView node={this.props._currentNode} toolbarReturn={this.onSelectListItem.bind()} getDataSet={this.getDataSet.bind()} onSelectItem={null} config={config} listItem={this.state.items}/>:null;
    
        return (
            <div className="view-content">
                {content}
            </div>
        )
    }

    // RENDER METHOD END //////////////////////////////
    ///////////////////////////////////////////////////

    render() {
        var content = this.buildContent();
    
        return (
          <div className="Adminpage View TreeListSplit">
            {content}
    
            {this.state.showForm?
              <ModalForm
                        onSaveData={this.onPopupSave.bind()}
                        show={this.state.showForm}
                        data={this.state.formData}
                        id={this.state.selectedObjectId}
                        node={this.props._currentNode} // FORM TO BE LOADED
                        onHandleClose={this.onClosePopup.bind()}
                        parentId={this.state.parentId}
              >
              </ModalForm>:null
            }
          </div>
        );
    }
   
}
 // END CLASS  //////////////////////////////////////////////////////




////////////////////////////////////////////////////////////////////
//////////////            REDUX              ///////////////////////
////////////////////////////////////////////////////////////////////
const mapStateToProps = (state) => {
  return {
    _nodes:state.appReducer.nodes,
    _currentNode:state.appReducer.currentNode,
    _dataset:state.apiReducer.workingData,
    _transfertObject:state.apiReducer.transfertObject,
    _TDI:state.apiReducer.TDI,
    _newObject:state.apiReducer.newObject,
    _loadedObject:state.apiReducer.loadedObject,
    _blankObjects:state.apiReducer.blankObjects,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    _clean_data: () => dispatch(repositoryActions.clean_data()),
    _update_sublevel:(name) =>dispatch(globalActions.update_sublevel(name)),
    _logError:(error,title,endPoint) =>dispatch(notificationAction.logError(error,title,endPoint)),
    _onCloseForm:() => dispatch(repositoryActions.onCloseForm()),
    _save_single_object: (sessionId,id,endPoint,object,page) =>dispatch(repositoryActions.save_single_object(sessionId,id,endPoint,object,page)),
    _delete_single_object: (sessionId,id,endPoint,object,page) =>dispatch(repositoryActions.delete_single_object(sessionId,id,endPoint,object,page)),
    _unarchive_single_object: (sessionId,id,endPoint,object,page) =>dispatch(repositoryActions.unarchive_single_object(sessionId,id,endPoint,object,page)),
    _create_single_object:(sessionId,object) =>dispatch(repositoryActions.create_single_object(sessionId,object)),
    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TreeListSplit);